module.exports = __webpack_public_path__ + "static/media/CosAssessmentsDashboards.ad34c6f3.png";